export const KR_VALUE_TYPES = {
  NUMBER: 1,
  PERCENT: 2,
  BINARY: 3,
  START_TARGET: 5,
  THRESHOLD: 6
}
export const DEFAULT_RESULT_TYPE_OPTIONS = [
  {
    icon: 'result-type-start-target',
    label: 'objectives.start_target',
    value: KR_VALUE_TYPES.START_TARGET,
    milestoneName: 'element_progress.milestone'
  },
  {
    icon: 'result-type-threshold',
    label: 'objectives.threshold',
    value: KR_VALUE_TYPES.THRESHOLD,
    milestoneName: 'element_progress.threshold'
    // unavailable: true
  },
  {
    icon: 'result-type-percent',
    label: 'objectives.percent',
    value: KR_VALUE_TYPES.PERCENT,
    deprecated: true
  },
  { icon: 'result-type-binary', label: 'objectives.binary', value: KR_VALUE_TYPES.BINARY },
  {
    icon: 'result-type-number',
    label: 'objectives.number',
    value: KR_VALUE_TYPES.NUMBER,
    deprecated: true
  }
]
